import isServer from '@/Framework/Router/Next/isServer';
import { createContainer, PageRenderingState } from '@/Framework/DI';
import { AppProps } from 'next/app';
import React from 'react';

export const configureApp = (Component) => {
  // On Server Side we need to recreate container for each request
  // On Client Side we need to remember container in the closure.
  const container = isServer() ? null : createContainer(PageRenderingState.ClientSideRendering);

  return (props: AppProps) => (props.pageProps.method === 'HEAD' ? null : (
    <Component
      container={ container || createContainer(PageRenderingState.ServerSideRendering) }
      { ...props }
    />
  ));
};
